/// <reference path="PlacementInfoBox.ts" />

namespace TerminalApp {
    export class LotInfoBox {
        placement_info_container = document.createElement("div");
        container: HTMLElement;
        inner_container: HTMLElement;
        text_container: HTMLElement;
        placementId: number;
        placementInfoBox: PlacementInfoBox;
        lot: SP.StockingLotInfo;
        constructor(lotInfo: SP.StockingLotInfo, description: string = null) {
            this.lot = lotInfo;
            this.placementId = lotInfo.stockPlacementId;
            this.container = document.createElement("div");
            this.inner_container = this.container.appendChild(document.createElement("div"));
            this.inner_container.classList.add("inner");
            this.container.classList.add("item_box1");
            this.inner_container.innerHTML += `<img class='image' src='${lotInfo.item.imageUrl}' />`;
            this.placement_info_container.style.pointerEvents = "none";
            this.inner_container.appendChild(this.placement_info_container);
            this.addExtraPlacmentInfoBox(lotInfo);

         

            var textContainer = this.text_container = this.inner_container.appendChild(document.createElement("div"));
            textContainer.classList.add("text");


            var barcodes = [];

            for (let code in lotInfo.item.allBarcodes) {
                let bc = code;
                if (lotInfo.item.allBarcodes[code] > 1) {
                    bc += " <span class='label'>COL " + lotInfo.item.allBarcodes[code] + "</span>";
                }
                barcodes.push(bc);
            }

            textContainer.innerHTML += `<span class='sku'>${lotInfo.item.sku}</span>`
            textContainer.innerHTML += `<span class='description'>${description ?? lotInfo.item.description}</span>`
            textContainer.innerHTML += `<span class='barcode'>${barcodes.join("<br >")}</span>`
            var clearFix = this.inner_container.appendChild(document.createElement("div"));
            clearFix.style.clear = "both";


            this.inner_container.querySelector(".image").addEventListener("click", (e) => {
                itemShortcutAssistant.open_with_info(lotInfo.item);
                e.preventDefault();
                e.stopPropagation();
            });
        }

        showMoreInitialized = false;
        addShowMoreButton() {
            if (!this.showMoreInitialized) {
                var button = document.createElement("div");
                button.classList.add("show-more-btn");
                button.innerHTML = SP.Localize("sentance_show_more_placements");
                this.showMoreInitialized = true;
                this.placement_info_container.appendChild(button);

                button.addEventListener("click", () => {
                    for (var i = 0; i < this.placement_info_container.children.length; i++) {
                        (this.placement_info_container.children[i] as HTMLElement).style.display = "block";
                        button.remove();
                    }
                });
            }

        }

        count: number = 0;
        addExtraPlacmentInfoBox(lot: SP.StockingLotInfo) {
            var box = new PlacementInfoBox(lot.stockPlacementData, true, this.lot.item, lot.placementQuantityItemAllLots);
            var container = document.createElement("div");
            container.style.position = "relative";
            container.style.whiteSpace = "nowrap";
            container.appendChild(box.container);
            this.count++;

            if (this.count > 5) {
                container.style.display = "none";
                this.addShowMoreButton();
            }

            

            //box.container.style.width = "60%";


            this.placement_info_container.appendChild(container);
            this.placementInfoBox ??= box; //set first placement

        }
    }






    export class LotInfoRefillBox {
        placement_info_container = document.createElement("div");
        container: HTMLElement;
        inner_container: HTMLElement;
        text_container: HTMLElement;
        placementInfoBox: PlacementInfoBox;

        renderPlacements(limit: number, item: SP.ItemInfo, data: SP.ItemRefillLotInfo[]) {
            this.placementInfoBox = null;
            this.placement_info_container.innerHTML = "";
            for (let i = 0; i < data.length; i++) {
                if (i >= limit) {
                    var button = document.createElement("div");
                    button.classList.add("show-more-btn");
                    button.innerHTML = SP.Localize("sentance_show_more_placements");
                    this.placement_info_container.appendChild(button);
                    button.addEventListener("click", () => {
                        this.renderPlacements(9999999999, item, data);
                    });
                    break;
                }


                let placement = data[i];
                this.addExtraPlacmentInfoBox(placement.placementData, item, placement.totalQty);

                
            }
        }

        constructor(lotInfo: SP.ItemRefillInfo) {
            this.container = document.createElement("div");
            this.inner_container = this.container.appendChild(document.createElement("div"));
            this.inner_container.classList.add("inner");
            this.container.classList.add("item_box1");
            this.inner_container.innerHTML += `<img class='image' src='${lotInfo.item.imageUrl}' />`;
            this.placement_info_container.style.pointerEvents = "none";
            this.inner_container.appendChild(this.placement_info_container);
            this.renderPlacements(5, lotInfo.item, lotInfo.placements);


            var textContainer = this.text_container = this.inner_container.appendChild(document.createElement("div"));
            textContainer.classList.add("text");

            var barcodes = [];
            for (let code in lotInfo.item.allBarcodes) {
                let bc = code;
                if (lotInfo.item.allBarcodes[code] > 1) {
                    bc += " <span class='label'>COL " + lotInfo.item.allBarcodes[code] + "</span>";
                }
                barcodes.push(bc);
            }

            textContainer.innerHTML += `<span class='sku'>${lotInfo.item.sku}</span>`
            textContainer.innerHTML += `<span class='description'>${lotInfo.item.description}</span>`
            textContainer.innerHTML += `<span class='barcode'>${barcodes.join("<br >")}</span>`
            var clearFix = this.inner_container.appendChild(document.createElement("div"));
            clearFix.style.clear = "both";


            this.inner_container.querySelector(".image").addEventListener("click", (e) => {
                itemShortcutAssistant.open_with_info(lotInfo.item);
                e.preventDefault();
                e.stopPropagation();
            });
        }


        addExtraPlacmentInfoBox(data: string, item: SP.ItemInfo, totalQty: number) {
            var box = new PlacementInfoBox(data, true, item, totalQty);
            var container = document.createElement("div");
            container.style.position = "relative";
            container.style.whiteSpace = "nowrap";
            container.appendChild(box.container);
            this.placement_info_container.appendChild(container);
            this.placementInfoBox ??= box; //set first placement

        }
    }
}